(function () {
    const resourcesListingWrap = document.querySelector('.section-resources-listing');
    const accordionResourcesWholeWrap = document.querySelector('.accordion.resources');
    const totalResources = document.querySelector('.total-resources');
    // Accordion Click Event
    const accordionAnchor = document.querySelectorAll(".resources-listing-search-info-wrap .accordion-body ul li a");
    const filterCross = document.querySelectorAll(".resources.filter-close");
    const searchField = document.getElementById("resources-search-field");
    const resourceListingWrap = document.querySelector('.resource-listing');
    const loader = document.querySelector('#loading');
    const loadMoreResources = document.querySelectorAll('.resources-load-more');
    let dataTax = '';
    let dataSlug = '';
    let resourcesCatObj = {};
    let resourcesObjects = '';
    if(resourcesListingWrap){
    for (let i = 0; i < accordionAnchor.length; i++) {
        accordionAnchor[i].addEventListener("click", function () {
            dataTax = accordionAnchor[i].getAttribute('data-tax');
            dataSlug = accordionAnchor[i].getAttribute('data-slug');
            // Check if the dataTax key already exists in tilesCatObj
            if (resourcesCatObj.hasOwnProperty(dataTax)) {
                // If yes, check if dataSlug already exists in the array
                if (!resourcesCatObj[dataTax].includes(dataSlug)) {
                    // If not, append dataSlug to the array
                    resourcesCatObj[dataTax].push(dataSlug);
                }
            } else {
                // If not, create a new key with an array containing dataSlug
                resourcesCatObj[dataTax] = [dataSlug];
            }
            if(searchField){
                searchField.value = '';
            }
            resourcesObjects = JSON.stringify(resourcesCatObj);
            if(!accordionAnchor[i].classList.contains('active')){
                filterResources(1,'',resourcesObjects);
            }
            accordionAnchor[i].classList.add('active');
        });
    }

    /*
     * Selecting all the load more buttons from resources
     */
    function loadMoreResourcesButton(){
        loadMoreResources.forEach((item)=>{
            item.addEventListener('click',()=>{
                console.log('clicked');
                let loadMoreButtonSelectedAttr = item.getAttribute('data-slug');
                let dataPage = item.getAttribute('data-page');
                item.setAttribute('data-page',parseInt(dataPage)+1);
                filterResources(dataPage,'','',loadMoreButtonSelectedAttr);
            });
        })
    }

    accordionResourcesWholeWrap.addEventListener('click',function(event){
        if (event.target.classList.contains('resources-load-more')) {
            const clickedButton = event.target;
            let loadMoreButtonSelectedAttr = clickedButton.getAttribute('data-slug');
            let dataPage = clickedButton.getAttribute('data-page');
            clickedButton.setAttribute('data-page',parseInt(dataPage)+1);
            filterResources(dataPage,'','',loadMoreButtonSelectedAttr);
        }
    })

    function hideLoadMoreButton(dataSlug = '',isFinalPage){
        let loadMoreCurrentButton = document.querySelector(".resources-load-more[data-slug='"+ dataSlug +"']");
        if(loadMoreCurrentButton){
            if(isFinalPage){
                loadMoreCurrentButton.classList.add('hide');
            }else{
                loadMoreCurrentButton.classList.remove('hide');
            }
        }
    }

    //clear anchor filter
    filterCross.forEach(function(item){
        item.addEventListener('click',function(){
            item.previousElementSibling.classList.remove('active');
            dataTax = item.previousElementSibling.getAttribute('data-tax');
            dataSlug = item.previousElementSibling.getAttribute('data-slug');
            // let searchValue = searchField.value;
            if (resourcesCatObj.hasOwnProperty(dataTax)) {
                let index = resourcesCatObj[dataTax].indexOf(dataSlug);
                if (index !== -1) {
                    resourcesCatObj[dataTax].splice(index, 1);
                    if (resourcesCatObj[dataTax].length === 0) {
                        delete resourcesCatObj[dataTax];
                    }
                }
            }
            let resourcesObjects = JSON.stringify(resourcesCatObj);
            resourcesObjects = resourcesObjects != '' ? resourcesObjects : '';
            filterResources(1,'',resourcesObjects);
        })
    })

    // Clear filter
    const clearFilter = document.querySelector(".reset-resources-filters");

    if (clearFilter) {
        clearFilter.addEventListener("click", function () {
            // Iterate through each accordion links and remove the active class
            if(searchField){
                searchField.value = '';
            }
            this.classList.add('spinning');
            accordionAnchor.forEach(function (item) {
                item.classList.remove('active');
            });
            filterResources(1,'','');
        });
    }

    if(searchField){
        searchField.addEventListener("keyup",debounce(function(e){
            if(e.key != "Enter"){
                const activeAnchorSelector = document.querySelector('.resources-listing-search-info-wrap .accordion-body ul li a.active');
                
                let searchValue = this.value;
                filterResources(1,searchValue,'','');
            }
        },1500));
    
        searchField.addEventListener("keypress",function(e){
            if(e.key == 'Enter'){
                e.preventDefault();
                const activeAnchorSelector = document.querySelector('.resources-listing-search-info-wrap .accordion-body ul li a.active');
                dataTax = '';
                dataSlug = '';
                if(activeAnchorSelector != null){
                    dataTax = activeAnchorSelector.getAttribute('data-tax');
                    dataSlug = activeAnchorSelector.getAttribute('data-slug');
                }
                if(!isEmpty(resourcesCatObj)){
                    resourcesObjects = JSON.stringify(resourcesCatObj);
                }else{
                    resourcesObjects = '';
                }
                let searchValue = this.value;
                filterResources(1,searchValue,'','');
            }
        });
    }
    
    //Debounce function
    function debounce(callback, delay) {
        let timeout;
        return function () {
            let args = arguments
            clearTimeout(timeout)
            timeout = setTimeout(function () {
                callback.apply(this, args)
            }.bind(this), delay)
        }
    }

    //Function to check empty object
    function isEmpty(obj) {
        return Object.keys(obj).length === 0;
    }

    // Filter product function
    function filterResources(page = 1,searchValue ='',resourcesObjects = '',loadMoreButtonAttr = '') {
        if(accordionResourcesWholeWrap){
            accordionResourcesWholeWrap.innerHTML += '<div id="loading" class="show"><div class="loader"></div></div>';
        }

        let filterData = "";

        filterData +="&searchValue=" + searchValue;
        filterData +="&resourcesObject=" + resourcesObjects;
        filterData +="&loadMoreDataTax=" + loadMoreButtonAttr;
        // Page data to send in request
        let pageData = "&pageNo=" + page;
        // let pageUrlValue = document.getElementById('page-url').value;
        // pageUrl = "&pageurl=" + pageUrlValue;

        // Ajax request
        let request = new XMLHttpRequest();
        request.open("POST", metz_ajax_callback_data.ajax_url, true);
        request.setRequestHeader(
        "Content-Type",
        "application/x-www-form-urlencoded; charset=UTF-8"
        );
        
        request.onreadystatechange = () => {
            if (request.readyState === 4) {
                const loadMoreGif = document.querySelector("#loading");
                if(loadMoreGif){
                    loadMoreGif.remove();
                }
                const responseData = JSON.parse(request.response);
                if (responseData.data.output === 'no-items' && totalResources) {
                    responseHtml = '<span class="no-result">No Results Found</span>';
                    totalResources.innerHTML = "0 Resources";
                }
                else {
                    if(clearFilter){
                        if(clearFilter.classList.contains('spinning')){
                            clearFilter.classList.remove('spinning');
                        }
                    }
                    responseHtml = responseData.data.output;
                    let foundPost = responseData.data.foundPost;
                    if(totalResources && loadMoreButtonAttr == ''){
                        totalResources.innerHTML = foundPost < 2 ? foundPost + " Resources" : foundPost >= 2 ? foundPost + " Resources" : foundPost + " Resource"; 
                    }

                }
                let resourcesListingAccordionWrap = document.querySelector('.resource-listing.'+loadMoreButtonAttr+'-listing');
                if(!isEmpty(loadMoreButtonAttr)){
                    resourcesListingAccordionWrap.innerHTML += responseHtml;
                }
                else{
                    accordionResourcesWholeWrap.innerHTML = responseHtml;
                }
                hideLoadMoreButton(responseData.data.dataSlug,responseData.data.finalPage);
            }
        };
        request.send(
        "action=resourceslistings&nonce=" +
            metz_ajax_callback_data.ajax_nonce +
            filterData+
            pageData
        );
    }
}//end of check for accordion resources
})();